import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.404 7.65c2.707-.21 4.98-.317 6.818-.317 1.839 0 4.111.106 6.818.318a3.889 3.889 0 0 1 3.576 3.602c.031.433.058.877.08 1.334l3.225-1.613a1.667 1.667 0 0 1 2.412 1.49v7.516a1.667 1.667 0 0 1-2.412 1.49l-3.226-1.613a52.56 52.56 0 0 1-.079 1.335 3.889 3.889 0 0 1-3.576 3.602c-2.704.211-4.976.317-6.818.317-1.842 0-4.114-.106-6.818-.317a3.889 3.889 0 0 1-3.576-3.602 70.606 70.606 0 0 1-.161-4.97c0-1.798.053-3.454.16-4.97a3.889 3.889 0 0 1 3.577-3.601Zm17.339 10.99 3.675 1.838a.556.556 0 0 0 .804-.497v-7.516a.555.555 0 0 0-.804-.497l-3.675 1.838a80.85 80.85 0 0 1 0 4.834ZM6.49 8.759a2.778 2.778 0 0 0-2.555 2.573 69.508 69.508 0 0 0-.158 4.89c0 1.773.053 3.403.158 4.891a2.778 2.778 0 0 0 2.555 2.573c2.677.21 4.922.314 6.731.314 1.81 0 4.054-.105 6.732-.314a2.778 2.778 0 0 0 2.554-2.573 69.51 69.51 0 0 0 .159-4.89c0-1.773-.053-3.404-.159-4.891a2.778 2.778 0 0 0-2.554-2.573c-2.68-.21-4.925-.314-6.732-.314-1.806 0-4.05.104-6.731.314Z",
    fill: "currentColor"
  }));
};

var SvgVideo = styled(SvgComponent).withConfig({
  displayName: "Video__SvgVideo",
  componentId: "sc-6wwk8h-0"
})(["", " ", ""], size, color);
export default SvgVideo;